/* Elderforge — Giveaway landing pages · v2
   Carousel (counter + progress + active slide), embers,
   count-up, sticky CTA, scroll reveals. No dependencies. */
(function () {
  'use strict';
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---- Carousel ---- */
  function initCarousel(root) {
    var track = root.querySelector('.gv-carousel__track');
    var slides = Array.prototype.slice.call(root.querySelectorAll('.gv-slide'));
    var prev = root.querySelector('[data-gv-prev]');
    var next = root.querySelector('[data-gv-next]');
    var countEl = root.querySelector('[data-gv-count]');
    var barEl = root.querySelector('[data-gv-progress]');
    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-gv-dot]'));
    var viewport = root.querySelector('.gv-carousel__viewport');
    if (!track || !slides.length) return;
    var total = slides.length;

    /* Desktop only: always show exactly 3 full slides (the original design),
       sized to fill the viewport edge-to-edge — never a count that leaves a
       trailing partial slide cropped at the boundary. Below 750px (mobile),
       leave the existing single-slide-peek behavior untouched. */
    var VISIBLE_DESKTOP = 3;
    function fitWholeSlides() {
      if (!viewport || slides.length < VISIBLE_DESKTOP) return;
      slides.forEach(function (s) { s.style.width = ''; });
      viewport.style.maxWidth = '';
      viewport.style.marginInline = '';
      if (window.innerWidth < 750) return;
      var trackStyle = getComputedStyle(track);
      var gap = parseFloat(trackStyle.columnGap) || 0;
      var trackPadX = parseFloat(trackStyle.paddingLeft) + parseFloat(trackStyle.paddingRight);
      /* Measure the track's own content box (its rendered width minus its own
         horizontal padding) — the track is what actually clips, and its padding
         is glow breathing room, not available slide space. */
      var available = track.getBoundingClientRect().width - trackPadX;
      var slideWidth = (available - gap * (VISIBLE_DESKTOP - 1)) / VISIBLE_DESKTOP;
      slides.forEach(function (s) { s.style.width = slideWidth.toFixed(1) + 'px'; });
    }

    function pad(n) { return (n < 10 ? '0' : '') + n; }

    function currentIndex() {
      var center = track.scrollLeft + track.clientWidth / 2;
      var best = 0, bestDist = Infinity;
      slides.forEach(function (s, i) {
        var mid = s.offsetLeft + s.offsetWidth / 2;
        var d = Math.abs(mid - center);
        if (d < bestDist) { bestDist = d; best = i; }
      });
      return best;
    }
    function scrollToIndex(i) {
      i = Math.max(0, Math.min(total - 1, i));
      var s = slides[i];
      track.scrollTo({ left: s.offsetLeft - (track.clientWidth - s.offsetWidth) / 2, behavior: reduce ? 'auto' : 'smooth' });
    }
    function update() {
      var i = currentIndex();
      slides.forEach(function (s, si) { s.classList.toggle('is-active', si === i); });
      if (countEl) countEl.innerHTML = '<b>' + pad(i + 1) + '</b> / ' + pad(total);
      if (barEl) barEl.style.width = ((i + 1) / total * 100) + '%';
      if (prev) prev.disabled = track.scrollLeft <= 2;
      if (next) next.disabled = track.scrollLeft >= track.scrollWidth - track.clientWidth - 2;
      dots.forEach(function (d, di) { d.classList.toggle('is-active', di === i); });
    }
    if (prev) prev.addEventListener('click', function () { scrollToIndex(currentIndex() - 1); });
    if (next) next.addEventListener('click', function () { scrollToIndex(currentIndex() + 1); });
    dots.forEach(function (d, i) { d.addEventListener('click', function () { scrollToIndex(i); }); });
    var raf;
    track.addEventListener('scroll', function () {
      if (raf) cancelAnimationFrame(raf);
      raf = requestAnimationFrame(update);
    }, { passive: true });
    root.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') { scrollToIndex(currentIndex() - 1); e.preventDefault(); }
      if (e.key === 'ArrowRight') { scrollToIndex(currentIndex() + 1); e.preventDefault(); }
    });
    window.addEventListener('resize', update, { passive: true });
    update();
    fitWholeSlides();
    var fitResizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(fitResizeTimer);
      fitResizeTimer = setTimeout(fitWholeSlides, 150);
    }, { passive: true });
  }

  /* ---- Embers ---- */
  function initEmbers() {
    if (reduce) return;
    Array.prototype.slice.call(document.querySelectorAll('.gv-embers')).forEach(function (box) {
      box.style.setProperty('--ember-travel', '-' + (box.getBoundingClientRect().height + 40).toFixed(0) + 'px');
      var n = parseInt(box.getAttribute('data-count') || '14', 10);
      for (var i = 0; i < n; i++) {
        var e = document.createElement('span');
        e.className = 'gv-ember';
        var size = (Math.random() * 2.5 + 1.5).toFixed(1);
        e.style.left = (Math.random() * 100) + '%';
        e.style.width = size + 'px';
        e.style.height = size + 'px';
        e.style.setProperty('--drift', (Math.random() * 80 - 40).toFixed(0) + 'px');
        e.style.animationDuration = (Math.random() * 6 + 7).toFixed(1) + 's';
        e.style.animationDelay = (Math.random() * 8).toFixed(1) + 's';
        box.appendChild(e);
      }
    });
  }

  /* ---- Count-up ---- */
  function initCountUp() {
    var els = Array.prototype.slice.call(document.querySelectorAll('[data-gv-countup]'));
    if (!els.length) return;
    function run(el) {
      var target = parseInt(el.getAttribute('data-gv-countup'), 10) || 0;
      if (reduce) { el.textContent = target; return; }
      var start = null, dur = 1300;
      function step(ts) {
        if (!start) start = ts;
        var p = Math.min((ts - start) / dur, 1);
        var eased = 1 - Math.pow(1 - p, 3);
        el.textContent = Math.round(eased * target);
        if (p < 1) requestAnimationFrame(step);
      }
      requestAnimationFrame(step);
    }
    if (!('IntersectionObserver' in window)) { els.forEach(run); return; }
    var io = new IntersectionObserver(function (ents) {
      ents.forEach(function (en) { if (en.isIntersecting) { run(en.target); io.unobserve(en.target); } });
    }, { threshold: 0.6 });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---- Sticky CTA ---- */
  function initSticky() {
    var sticky = document.querySelector('.gv-sticky');
    var hero = document.querySelector('.gv-hero');
    var closing = document.querySelector('.gv-closing');
    if (!sticky || !hero) return;
    var pastHero = false, atEnd = false;
    function apply() { sticky.classList.toggle('is-shown', pastHero && !atEnd); }
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (e) { pastHero = !e[0].isIntersecting; apply(); }, { threshold: 0 })
        .observe(hero);
      if (closing) new IntersectionObserver(function (e) { atEnd = e[0].isIntersecting; apply(); }, { threshold: 0.2 })
        .observe(closing);
    }
  }

  /* ---- Scroll reveals ---- */
  function initReveal() {
    var els = Array.prototype.slice.call(document.querySelectorAll('.gv-inview'));
    if (!els.length) return;
    if (!('IntersectionObserver' in window)) { els.forEach(function (el) { el.classList.add('is-visible'); }); return; }
    var io = new IntersectionObserver(function (ents) {
      ents.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-visible'); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---- Sync §4 ("The Prize") top gap to §3 ("The Curators") bottom gap ----
     clamp()-based CSS can't be made to match exactly across viewports because
     the two gaps are shaped by different content (icon-column row height vs.
     eyebrow line-box), so measure both live and set an exact px padding-top. */
  function syncPrizeTopGap() {
    var b3 = document.querySelector('.gv-band--b3');
    var b3Text = b3 && b3.querySelector('.gv-band__text');
    var showcase = document.querySelector('.gv-show.gv-band--torch');
    var eyebrow = showcase && showcase.querySelector('.gv-eyebrow');
    if (!b3 || !b3Text || !showcase || !eyebrow) return;

    /* Elements not yet scroll-revealed still carry the .gv-inview
       translateY(28px) offset, which skews getBoundingClientRect() away
       from their resting position. Neutralize it for the measurement only. */
    var pending = Array.prototype.slice.call(document.querySelectorAll('.gv-inview:not(.is-visible)'));
    pending.forEach(function (el) { el.style.transition = 'none'; el.style.transform = 'none'; });

    showcase.style.paddingTop = '';
    var targetGap = b3.getBoundingClientRect().bottom - b3Text.getBoundingClientRect().bottom;
    var currentPadding = parseFloat(getComputedStyle(showcase).paddingTop) || 0;
    var currentGap = eyebrow.getBoundingClientRect().top - showcase.getBoundingClientRect().top;
    var newPadding = Math.max(currentPadding - (currentGap - targetGap), 0);
    showcase.style.paddingTop = newPadding.toFixed(1) + 'px';

    pending.forEach(function (el) { el.style.transform = ''; el.style.transition = ''; });
  }

  /* ---- Sync the Prize section's bottom gap to its own (already-correct) top gap ----
     Since the midcta section below it was removed, this section's own bottom
     padding (a plain clamp(), unrelated to the hand-tuned top value) needs to
     match the top so the spacing reads symmetric now that nothing follows it
     before the next section starts. */
  function syncPrizeBottomGap() {
    var showcase = document.querySelector('.gv-show.gv-band--torch');
    var eyebrow = showcase && showcase.querySelector('.gv-eyebrow');
    var ledes = showcase ? showcase.querySelectorAll('.gv-lede') : [];
    var supportLine = ledes.length ? ledes[ledes.length - 1] : null;
    if (!showcase || !eyebrow || !supportLine) return;

    var pending = Array.prototype.slice.call(document.querySelectorAll('.gv-inview:not(.is-visible)'));
    pending.forEach(function (el) { el.style.transition = 'none'; el.style.transform = 'none'; });

    var topGap = eyebrow.getBoundingClientRect().top - showcase.getBoundingClientRect().top;
    showcase.style.paddingBottom = '';
    var currentPadding = parseFloat(getComputedStyle(showcase).paddingBottom) || 0;
    var currentGap = showcase.getBoundingClientRect().bottom - supportLine.getBoundingClientRect().bottom;
    var newPadding = Math.max(currentPadding - (currentGap - topGap), 0);
    showcase.style.paddingBottom = newPadding.toFixed(1) + 'px';

    pending.forEach(function (el) { el.style.transform = ''; el.style.transition = ''; });
  }

  /* ---- Sync §6 (Instant Gift) top padding to §5's resolved value, and its own
     bottom gap to its own top gap ---- §5's top gap has no quirk to solve for
     (same bare eyebrow structure as §6), so copying its top padding is exact.
     But §5's bottom padding is compensated for a paragraph's default browser
     margin that §6 doesn't have (it ends in an image grid, not a paragraph) —
     copying that value verbatim under-pads §6's bottom. Measure §6's own
     bottom gap (grid to section edge) against its own top gap instead. */
  function syncTreesGaps() {
    var torch = document.querySelector('.gv-show.gv-band--torch');
    var cold = document.querySelector('.gv-show.gv-band--cold');
    var eyebrow = cold && cold.querySelector('.gv-eyebrow');
    var grid = cold && cold.querySelector('.gv-trees');
    if (!torch || !cold || !eyebrow || !grid) return;

    cold.style.paddingTop = getComputedStyle(torch).paddingTop;

    var pending = Array.prototype.slice.call(document.querySelectorAll('.gv-inview:not(.is-visible)'));
    pending.forEach(function (el) { el.style.transition = 'none'; el.style.transform = 'none'; });

    var topGap = eyebrow.getBoundingClientRect().top - cold.getBoundingClientRect().top;
    cold.style.paddingBottom = '';
    var currentPadding = parseFloat(getComputedStyle(cold).paddingBottom) || 0;
    var currentGap = cold.getBoundingClientRect().bottom - grid.getBoundingClientRect().bottom;
    var newPadding = Math.max(currentPadding - (currentGap - topGap), 0);
    cold.style.paddingBottom = newPadding.toFixed(1) + 'px';

    pending.forEach(function (el) { el.style.transform = ''; el.style.transition = ''; });
  }

  /* ---- Sync closing CTA's top/bottom padding to match Instant Gift (cold) ----
     Closing is a plain padding-based section (no inset panel, no eyebrow-
     relative quirk), so a direct copy of cold's resolved values is exact. */
  function syncClosingGaps() {
    var cold = document.querySelector('.gv-show.gv-band--cold');
    var closing = document.querySelector('.gv-closing');
    if (!cold || !closing) return;
    closing.style.paddingTop = getComputedStyle(cold).paddingTop;
    closing.style.paddingBottom = getComputedStyle(cold).paddingBottom;
  }

  function syncPrizeGaps() {
    syncPrizeTopGap();
    syncPrizeBottomGap();
    syncTreesGaps();
    syncClosingGaps();
  }

  function init() {
    Array.prototype.slice.call(document.querySelectorAll('[data-gv-carousel]')).forEach(initCarousel);
    initEmbers();
    initCountUp();
    initSticky();
    initReveal();
    syncPrizeGaps();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(syncPrizeGaps);
  var gvGapResizeTimer;
  window.addEventListener('resize', function () {
    clearTimeout(gvGapResizeTimer);
    gvGapResizeTimer = setTimeout(syncPrizeGaps, 150);
  }, { passive: true });
})();
